import { Fragment, useState } from 'react';
import styles from './styles.module.scss';
import { DownloadFilesModal } from 'pages/Workshop/Forms/components/FormDetailModal/components';

export const DownloadButton = (props) => {
  const [filesModalOpen, setFilesModalOpen] = useState(false);

  return (
    <Fragment>
      <DownloadFilesModal
        isOpen={filesModalOpen}
        onClose={() => setFilesModalOpen(false)}
        auditTrailDocuments={[]}
        {...props}
      />

      <div onClick={() => setFilesModalOpen(true)}>
        {props.downloadButton || (
          <button testid="download" className={styles.download}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.3335 16.166V17.8327C5.3335 18.2747 5.50909 18.6986 5.82165 19.0112C6.13421 19.3238 6.55814 19.4993 7.00016 19.4993H17.0002C17.4422 19.4993 17.8661 19.3238 18.1787 19.0112C18.4912 18.6986 18.6668 18.2747 18.6668 17.8327V16.166"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.8335 11L12.0002 15.1667L16.1668 11"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 5V15"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
      </div>
    </Fragment>
  );
};
